
<div class="w-full px-4">
  <div class="w-full flex flex-column gap-3">
      <div class="grid">
          <h1 class="text-left col-10 font-bold text-4xl">School Manager</h1>
          <p-button icon="pi pi-user-plus" (click)="addSchoolDialog()" label="Add School" class="col-2 flex flex-column gap-1" styleClass="submitBtn" />
      </div>
    <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
      <h2 class="text-left font-medium text-2xl" style="color: #303030;">Search</h2>
      <form [formGroup]="filterForm" (ngSubmit)="getSchools(1)" class="w-full flex flex-wrap">
        <div class="w-full grid">
          <!-- <div class="col-2 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">From Date</b>
            <p-calendar placeholder="From date" formControlName="fromDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
              class="w-full" styleClass="fullWidth" />
          </div>
          <div class="col-2 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">To Date</b>
            <p-calendar placeholder="To Date" formControlName="toDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
              class="w-full" styleClass="fullWidth" />
          </div> -->
          <div class="col-3 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">School Name</b>
            <p-autoComplete formControlName= "schoolName" [suggestions]="schoolNames"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('schoolName')?.value}"
              class="w-full" (completeMethod)="filterSchoolNames($event)" styleClass="fullWidth" optionValue="name"
              optionLabel="name" >
            </p-autoComplete>
          </div>
          <div class="col-3 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">State</b>
            <p-dropdown [options]="schoolStateOptions" styleClass="selectFull" class="w-full" optionLabel="name"
              optionValue="value" formControlName="schoolState" filterBy="name" [showClear]="true"
              appendTo="body" placeholder="Select School-State">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>{{ selectedOption.name }}</div>
                </div>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ option.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="col-2">
            <div class="w-full" style="padding-top: 23px;">
              <p-button type="submit" label="Search" class="w-full" styleClass="submitBtn" />
            </div>
          </div>
      </div>
    </form>
    </div>

    <div class="w-full">
      <p-table  *ngIf="schoolList && schoolList.length > 0; else noRecordsFound" [value]="schoolList"
        [paginator]="schoolList.length!=totalRecords" [alwaysShowPaginator]="true" [rows]="rowSize" [totalRecords]="totalRecords" [first]="first" [lazy]="true"
        [lazyLoadOnInit]="false" [loading]="isLoading" [loadingIcon]="'pi pi-spinner'" [showCurrentPageReport]="true"
        (onLazyLoad)="onLazyLoad($event)" [rowsPerPageOptions]="[10, 20, 30]" [showPageLinks]="true"
        styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>School Name</th>
            <th>Address</th>
            <th>Zipcode</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Website</th>
            <th>Code</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-school>

          <tr>
            <td>{{school.name}}</td>
            <td>{{school.address}}</td>
            <td>{{school.zipCode}}</td>
            <td>{{school.email}}</td>
            <td>{{school.phoneNumber}}</td>
            <td>{{school.website}}</td>
            <td>{{school.code}}</td>
            <td>
              <p-button class="px-2" [loading]="isLoading" label="Edit" icon="pi pi-pen-to-square"
                    styleClass="w-7rem viewapplication" (click)="addSchoolDialog(school)" />
              <p-toggleButton
              [ngModel]="school.isActive"
              (onChange)="updateSchoolStatus(school.id)"
              onLabel="Active"
              offLabel="Inactive"
              [onIcon]="'pi pi-check'"
              offIcon="pi pi-times"
              styleClass="w-9rem toggleBtn"
              ariaLabel="Do you confirm" />
              <p-button class="px-2" [loading]="isLoading" label="Admin" icon="pi pi-user-edit"
              styleClass="viewapplication" (click)="adminDialog(school.id)"/>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <ng-template #noRecordsFound>
        <div class="w-full flex flex-column align-items-center py-4 gap-5">
          <div class="w-full flex align-items-center justify-content-center">
            <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
          </div>
          <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<p-dialog [header]="schoolToEdit ? 'Update School' : 'New School'" [(visible)]="isAddSchoolVisible" [modal]="true" (visibleChange)="onSchoolDialogVisibilityChange($event)" [style]="{ width: '70rem' }">
  <div class="w-full ">
    <div class="w-full flex flex-column gap-3">
      <form (ngSubmit)="upsertSchool()" [formGroup]="newSchoolForm">
          <div class="w-full flex flex-column gap-2 ">
              <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">School Information</h2>
              <div class="w-full flex flex-wrap">
                  <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                    <b class="text-left font-normal text-base" style="color: #424242;">Name</b>
                    <input pInputText formControlName="name" type="text" class="inputField">
                    <small class="ng-dirty ng-invalid text-red-500"
                        *ngIf="newSchoolForm.get('name')?.invalid && (submitted || newSchoolForm.get('name')?.touched)">
                        Name is required
                    </small>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                    <b class="text-left font-normal text-base" style="color: #424242;">Address</b>
                    <input pInputText formControlName="address" type="text" class="inputField">
                    <small class="ng-dirty ng-invalid text-red-500"
                        *ngIf="newSchoolForm.get('address')?.invalid && (submitted || newSchoolForm.get('address')?.touched)">
                        Address is required
                    </small>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                    <b class="text-left font-normal text-base" style="color: #424242;">City</b>
                    <input pInputText formControlName="city" type="text" class="inputField">
                    <small class="ng-dirty ng-invalid text-red-500"
                        *ngIf="newSchoolForm.get('city')?.invalid && (submitted || newSchoolForm.get('city')?.touched)">
                        City is required
                    </small>
                  </div>
                <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                  <b class="text-left font-normal text-base" style="color: #424242;">State</b>
                  <input pInputText formControlName="state" type="text" class="inputField">
                  <small class="ng-dirty ng-invalid text-red-500"
                      *ngIf="newSchoolForm.get('state')?.invalid && (submitted || newSchoolForm.get('state')?.touched)">
                      State is required
                  </small>
                </div>
                <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                  <b class="text-left font-normal text-base" style="color: #424242;">ZipCode</b>
                  <input pInputText formControlName="zipCode" type="text" class="inputField">
                  <small class="ng-dirty ng-invalid text-red-500"
                      *ngIf="newSchoolForm.get('zipCode')?.invalid && (submitted || newSchoolForm.get('zipCode')?.touched)">
                      ZipCode is missing or invalid
                  </small>
                </div>
                  <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                      <b class="text-left font-normal text-base" style="color: #424242;">Country</b>
                      <p-dropdown [options]="countries" [showClear]="true" formControlName="country"
                          [ngClass]="{'ng-invalid ng-dirty' : submitted && !newSchoolForm.value.country}" optionLabel="name"
                          optionValue="name"  [filter]="true" placeholder="Select a country" styleClass="dropdown selectFull" appendTo="body" class="w-full" >
                          <ng-template pTemplate="selectedItem" let-selectedOption>
                              <div class="flex align-items-center gap-2">
                              <div>{{ selectedOption.name }}</div>
                              </div>
                          </ng-template>
                          <ng-template let-country pTemplate="item">
                              <div class="flex align-items-center gap-2">
                              <div>{{ country.name }}</div>
                              </div>
                          </ng-template>
                      </p-dropdown>
                      <small class="ng-dirty ng-invalid text-red-500"
                          *ngIf="newSchoolForm.get('country')?.invalid && (submitted || newSchoolForm.get('country')?.touched)">
                          Select your gender
                      </small>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                      <b class="text-left font-normal text-base" style="color: #424242;">Email Address</b>
                      <input pInputText formControlName="email" type="text" class="inputField">
                      <small class="ng-dirty ng-invalid text-red-500"
                          *ngIf="newSchoolForm.get('email')?.invalid && (submitted || newSchoolForm.get('email')?.touched)">
                          Email is missing or invalid
                      </small>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                      <b class="text-left font-normal text-base" style="color: #424242;">Contact Number</b>
                      <input pInputText formControlName="phoneNumber" type="text" class="inputField">
                      <small class="ng-dirty ng-invalid text-red-500"
                          *ngIf="newSchoolForm.get('phoneNumber')?.invalid && (submitted || newSchoolForm.get('phoneNumber')?.touched)">
                          Phone Number is missing or invalid
                      </small>
                  </div>
                  <!-- <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                      <b class="text-left font-normal text-base" style="color: #424242;">Upload Image</b>
                      <p-fileUpload
                      #fileUploader
                      mode="basic"

                      (onSelect)="onFileSelect($event)"
                      [auto]="false"
                      chooseLabel="Choose"
                      chooseIcon="pi pi-upload"
                      name="demo[]"
                      url="https://www.primefaces.org/cdn/api/upload.php"
                      accept=".jpg,.png,.jpeg"
                      maxFileSize="1000000" class="w-full" styleClass="upload_w" />
                  </div> -->
                  <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                      <b class="text-left font-normal text-base" style="color: #424242;">Website</b>
                      <input pInputText formControlName="website" type="text" class="inputField">
                      <small class="ng-dirty ng-invalid text-red-500"
                          *ngIf="newSchoolForm.get('website')?.invalid && (submitted || newSchoolForm.get('website')?.touched)">
                          Website is invalid
                      </small>
                  </div>
                  <!-- <div  class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                      <b class="text-left font-normal text-base" style="color: #424242;">Admin State</b>
                      <p-dropdown  formControlName="state" [options]="adminStateOptions" styleClass="selectFull" class="w-full" optionLabel="name"
                      optionValue="value"      filterBy="name" [showClear]="true"
                      appendTo="body" placeholder="Select Admin-State">

                      </p-dropdown>
                  </div> -->

              </div>
          </div>
          <div class="w-full flex align-items-center justify-content-center mt-3">
              <p-button [disabled]="newSchoolForm.invalid" [loading]="isLoading" label="Submit" styleClass="save_btn1" type="submit"/>
          </div>
      </form>
    </div>
  </div>
</p-dialog>

<p-dialog [header]="adminToEdit ? 'Update Admin' : 'Add Admin'" [(visible)]="isAdminVisible" [modal]="true" (visibleChange)="onAdminDialogVisibilityChange($event)" [style]="{ width: '70rem' }">
  <div class="w-full ">
    <div class="w-full flex flex-column gap-3">
      <form (ngSubmit)="addSchoolAdmin()" [formGroup]="schoolAdminForm" autocomplete="off">
          <div class="w-full flex flex-column gap-2 ">
              <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">School-Admin Information</h2>
              <div class="w-full flex flex-wrap">
                  <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                    <b class="text-left font-normal text-base" style="color: #424242;">First Name</b>
                    <input pInputText formControlName="firstName" type="text" class="inputField">
                    <small class="ng-dirty ng-invalid text-red-500"
                        *ngIf="schoolAdminForm.get('firstName')?.invalid && (submitted || schoolAdminForm.get('firstName')?.touched)">
                        First Name is required
                    </small>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                    <b class="text-left font-normal text-base" style="color: #424242;">Last Name</b>
                    <input pInputText formControlName="lastName" type="text" class="inputField">
                    <small class="ng-dirty ng-invalid text-red-500"
                        *ngIf="schoolAdminForm.get('lastName')?.invalid && (submitted || schoolAdminForm.get('lastName')?.touched)">
                        Last Name is required
                    </small>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                    <b class="text-left font-normal text-base" style="color: #424242;">Email Address</b>
                    <input pInputText formControlName="email" type="text" class="inputField" autocomplete="off">
                    <small class="ng-dirty ng-invalid text-red-500"
                        *ngIf="schoolAdminForm.get('email')?.invalid && (submitted || schoolAdminForm.get('email')?.touched)">
                        Email is missing or invalid
                    </small>
                  </div>
                  <div *ngIf="!hidePasswordFields" class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                    <b class="text-left font-normal text-base" style="color: #424242;">New Password</b>
                    <p-password formControlName="newPassword" [feedback]="false" class="w-full" styleClass="inputField" autocomplete="off"/>
                    <small class="ng-dirty ng-invalid text-red-500"
                      *ngIf="(schoolAdminForm.controls['newPassword'].touched || submitted) && schoolAdminForm.controls['newPassword'].errors">
                      <ng-container *ngIf="schoolAdminForm.controls['newPassword'].errors['required']">New password is
                        required</ng-container>
                      <ng-container
                        *ngIf="!schoolAdminForm.controls['newPassword'].errors['required'] && schoolAdminForm.controls['newPassword'].errors['minlength']">Password
                        must be at
                        least 8 characters</ng-container>
                      <ng-container
                        *ngIf="!schoolAdminForm.controls['newPassword'].errors['required'] && !schoolAdminForm.controls['newPassword'].errors['minlength'] && schoolAdminForm.controls['newPassword'].errors['uppercase']">Password
                        must contain at least one uppercase letter</ng-container>
                      <ng-container
                        *ngIf="!schoolAdminForm.controls['newPassword'].errors['required'] && !schoolAdminForm.controls['newPassword'].errors['minlength'] && !schoolAdminForm.controls['newPassword'].errors['uppercase'] && schoolAdminForm.controls['newPassword'].errors['lowercase']">Password
                        must contain at least one lowercase letter</ng-container>
                      <ng-container
                        *ngIf="!schoolAdminForm.controls['newPassword'].errors['required'] && !schoolAdminForm.controls['newPassword'].errors['minlength'] && !schoolAdminForm.controls['newPassword'].errors['uppercase'] && !schoolAdminForm.controls['newPassword'].errors['lowercase'] && schoolAdminForm.controls['newPassword'].errors['digit']">Password
                        must contain at least one digit</ng-container>
                      <ng-container
                        *ngIf="!schoolAdminForm.controls['newPassword'].errors['required'] && !schoolAdminForm.controls['newPassword'].errors['minlength'] && !schoolAdminForm.controls['newPassword'].errors['uppercase'] && !schoolAdminForm.controls['newPassword'].errors['lowercase'] && !schoolAdminForm.controls['newPassword'].errors['digit'] && schoolAdminForm.controls['newPassword'].errors['specialChar']">Password
                        must contain at least one special character</ng-container>
                      <ng-container
                        *ngIf="!schoolAdminForm.controls['newPassword'].errors['required'] && !schoolAdminForm.controls['newPassword'].errors['minlength'] && !schoolAdminForm.controls['newPassword'].errors['uppercase'] && !schoolAdminForm.controls['newPassword'].errors['lowercase'] && !schoolAdminForm.controls['newPassword'].errors['digit'] && !schoolAdminForm.controls['newPassword'].errors['specialChar'] && schoolAdminForm.controls['newPassword'].errors['uniqueChars']">Password
                        must contain at least 3 unique characters</ng-container>
                    </small>
                  </div>
                  <div *ngIf="!hidePasswordFields" class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                    <b class="text-left font-normal text-base" style="color: #424242;">Confirm Password</b>
                    <p-password formControlName="confirmPassword" [feedback]="false" class="w-full" styleClass="inputField" />
                    <small class="ng-dirty ng-invalid text-red-500"
                      *ngIf="(schoolAdminForm.controls['confirmPassword'].touched || submitted) && (schoolAdminForm.controls['confirmPassword'].errors || schoolAdminForm.errors?.['passwordMismatch'])">
                      <ng-container *ngIf="schoolAdminForm.controls['confirmPassword'].errors?.['required']">Confirm password
                        is required</ng-container>
                      <ng-container *ngIf="schoolAdminForm.errors?.['passwordMismatch']">Passwords do not match</ng-container>
                    </small>
                  </div>
              </div>
          </div>
          <div *ngIf="!hidePasswordFields" class="w-full flex align-items-center justify-content-center mt-3">
              <p-button [disabled]="schoolAdminForm.invalid" [loading]="isLoading" label="Submit" styleClass="save_btn1" type="submit"/>
          </div>
      </form>
    </div>
  </div>
</p-dialog>
